"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7329],{

/***/ 37329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ themeOptions; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93894);

var themeOptions = {
    palette: {
        primary: {
            light: "#0000E7",
            main: "#0000B9",
            dark: "#00008b",
            contrastText: "#fff",
            100: "#DCE8FD",
            200: "#B8D2FF",
            300: "#5B91FC",
            400: "#1D65F5",
            500: "#0C55F2",
            600: "#1616FF",
            700: "#0000E7",
            800: "#0000b9",
            900: "#00008b",
            950: "#000066"
        },
        secondary: {
            light: "#786400",
            main: "#FFA500",
            dark: "#504304",
            contrastText: "#fff",
            100: "#FFE0AE",
            200: "#FFD68A",
            300: "#FFC55C",
            400: "#FFB52E",
            500: "#FFA500",
            600: "#F88F23",
            700: "#D18700",
            800: "#A36A00",
            900: "#754C00"
        },
        success: {
            light: "#ACE266",
            main: "#5DA600",
            dark: "#5DA800",
            contrastText: "#fff",
            100: "#5DA600",
            200: "#5DA600",
            300: "#F8FDF2",
            400: "#E3F5CC",
            500: "#ACE266",
            600: "#90D933",
            700: "#74CF00"
        },
        success2: {
            light: "#72CDB8",
            main: "#119273",
            dark: "#119290",
            contrastText: "#fff",
            100: "#D0EEE7",
            200: "#43BDA0",
            300: "#F3FBF9 ",
            400: "#D0EEE7",
            500: "#72CDB8",
            600: "#43BDA0",
            700: "#14AC88 "
        },
        error: {
            light: "#F9DDDD",
            main: "#BE3737",
            dark: "#E05777",
            contrastText: "#fff",
            100: "#BE3737",
            200: "#BE3737",
            300: "#FEF7F7 ",
            400: "#F9DDDD",
            500: "#EC9999",
            600: "#E67777",
            700: "#E05555 "
        },
        warning: {
            light: "#F9C77B",
            main: "#E48900",
            dark: "#E48919",
            contrastText: "#fff",
            100: "#E48900",
            200: "#E48900",
            300: "#FFFAF4  ",
            400: "#FDECD3",
            500: "#F9C77B",
            600: "#F7B44F",
            700: "#F5A123 "
        },
        info: {
            light: "#6CCAF2",
            main: "#007EB4",
            dark: "#007EB8",
            contrastText: "#fff",
            100: "#007EB4",
            200: "#007EB4",
            300: "#F3FBFE   ",
            400: "#CEEDFB",
            500: "#6CCAF2",
            600: "#3BB8EE",
            700: "#0AA7EA "
        },
        grey: {
            100: "#E8E9F0",
            200: "#F6F7F9",
            300: "#FFFFFF"
        },
        text: {
            primary: "#FFFFFF",
            secondary: "#83819B",
            disabled: "#9B9BC4",
            hint: "#C0BFCC",
            dark: "#25233D"
        },
        divider: "#ecedef",
        background: {
            paper: "#F6F7F9",
            paper2: "#E8E9F0",
            default: "#F6F7F9",
            light: "#ffffff"
        },
        common: {
            white: "#fff",
            black: "#000"
        }
    },
    shadows: [
        "none",
        "0px 24px 40px -8px rgba(0, 0, 0, 0.06)",
        "0px 6px 25px -6px rgba(0, 0, 0, 0.14)",
        "0px 18px 33px rgba(166, 94, 75, 0.35)",
        "0 10px 50px 0 rgba(0, 0, 0, 0.1)",
        "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
        "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
        "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
        "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
        "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
        "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
        "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
        "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
        "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
        "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
        "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
        "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
        "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
        "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
        "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
        "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
        "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
        "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
        "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
        "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)", 
    ],
    typography: {
        htmlFontSize: 10,
        fontFamily: [
            "Yekan Bakh"
        ].join(", "),
        fontSize: 16,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: {
            fontSize: "4.8rem !important"
        },
        h2: {
            fontSize: "4rem !important"
        },
        h3: {
            fontSize: "3.2rem !important"
        },
        h4: {
            fontSize: "2.4rem !important"
        },
        h5: {
            fontSize: "2rem !important"
        },
        h6: {
            fontSize: "1.8rem !important"
        },
        subtitle1: {
            fontSize: "1.6rem !important"
        },
        subtitle2: {
            fontSize: "1.4rem !important "
        },
        body1: {
            fontSize: "1.4rem !important"
        },
        body2: {
            fontSize: "1.2rem !important"
        },
        button: {
            fontSize: "1.6rem !important"
        },
        caption: {
            fontSize: "1rem !important"
        },
        overline: {
            fontSize: "1rem !important",
            fontWeight: "bold",
            lineHeight: "1.3"
        }
    },
    shape: {
        borderRadius: 8,
        small: 8,
        medium: 12,
        large: 16,
        xLarge: 24
    },
    zIndex: {
        mobileStepper: 1000,
        speedDial: 1050,
        appBar: 1100,
        drawer: 5000,
        modal: 1300,
        snackbar: 1400,
        tooltip: 1500
    },
    transitions: {
        easing: {
            // This is the most common easing curve.
            easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
            // Objects enter the screen at full velocity from off-screen and
            // slowly decelerate to a resting point.
            easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
            // Objects leave the screen at full velocity. They do not decelerate when off-screen.
            easeIn: "cubic-bezier(0.4, 0, 1, 1)",
            // The sharp curve is used by objects that may return to the screen at any time.
            sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
            shortest: 150,
            shorter: 200,
            short: 250,
            // most basic recommended timing
            standard: 300,
            // this is to be used in complex animations
            complex: 375,
            // recommended when something is entering screen
            enteringScreen: 225,
            // recommended when something is leaving screen
            leavingScreen: 195
        }
    },
    components: {
        MuiContainer: {
            styleOverrides: {
                maxWidthMd: "92.2rem !important",
                maxWidthLg: "144.0rem !important",
                maxWidthXl: "154.0rem !important",
                // new
                root: {
                    maxWidth: "144rem !important"
                }
            },
            defaultProps: {
                maxWidth: "144rem !important"
            }
        },
        MuiDrawer: {
            styleOverrides: {
                root: {
                    "& .MuiPaper-root": {
                        borderRadius: "0 1.2rem 1.2rem 0",
                        width: "85%"
                    }
                },
                paperAnchorBottom: {
                    height: "60%",
                    width: "100% !important",
                    borderRadius: "0 1.2rem 1.2rem 0 !important"
                },
                paperAnchorTop: {
                    height: "60%",
                    width: "100% !important",
                    borderRadius: "0 1.2rem 1.2rem 0 !important"
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: "#EBEBF1"
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    fontSize: "62.5%",
                    "@media (min-width:1200px) and (max-width:1300px)": {
                        fontSize: "47%"
                    },
                    "@media (min-width:1300px) and (max-width:1510px)": {
                        fontSize: "62.5%"
                    },
                    "@media (min-width:1510px) and (max-width:1600px)": {
                        fontSize: "60%"
                    }
                },
                body: {
                    overflowX: "hidden",
                    height: "100% !important"
                },
                a: {
                    color: "inherit",
                    textDecoration: "none"
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    background: "#FFF",
                    color: "#83819B",
                    "& input::placeholder": {
                        color: "#83819B"
                    },
                    "& fieldset": {
                        "&:focus": {
                            borderColor: "transparent"
                        },
                        borderColor: "transparent"
                    },
                    "&.Mui-disabled": {
                        background: "#eee",
                        opacity: 0.8,
                        color: "#FFF",
                        "& input::placeholder": {
                            color: "#FFF"
                        }
                    },
                    "&.MuiFormHelperText": {
                        textAlign: "unset !important"
                    },
                    "&:hover": {
                        "& $notchedOutline": {
                            borderColor: "#b5b5b5",
                            borderWidth: "1px"
                        }
                    },
                    "&:focus": {
                        "& $notchedOutline": {
                            boxShadow: "-1px 3px 10px 0 rgb(0 0 0 / 6%)"
                        }
                    }
                },
                notchedOutline: {
                    borderColor: "#ecedef",
                    borderWidth: "1px"
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    textAlign: "unset !important",
                    margin: "0.8rem 1.0rem 0 0 !important",
                    fontSize: "1.3rem !important"
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    color: "#363636",
                    fontSize: "1.4rem",
                    lineHeight: "1.5",
                    "& input": {
                        "&::placeholder": {
                            fontSize: "1.3rem !important"
                        }
                    }
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    color: "#000",
                    "&$focused": {
                        color: "auto"
                    }
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    "&.Mui-disabled": {
                        backgroundColor: "transparent !important"
                    },
                    position: "absolute",
                    left: "5rem",
                    right: "unset",
                    top: "0",
                    transformOrigin: "top left"
                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    overflow: "visible"
                },
                scroller: {
                    "@media (min-width:1440px)": {
                        overflow: "visible !important"
                    },
                    "@media (max-width:1440px)": {
                        backgroundColor: "#fff"
                    }
                }
            }
        },
        MuiStepLabel: {
            styleOverrides: {
                label: {
                    color: "#565a64",
                    fontWeight: "normal",
                    "&.MuiStepLabel-active": {
                        color: "#1a879f",
                        fontWeight: "bold"
                    },
                    "&.MuiStepLabel-completed": {
                        color: "#565a64",
                        fontWeight: "normal"
                    }
                }
            }
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    "&.MuiPaper-root ": {
                        boxShadow: "unset",
                        backgroundColor: "transparent"
                    }
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: "#f7f7f8",
                    borderRadius: 12
                }
            }
        },
        MuiTableBody: {
            styleOverrides: {
                root: {
                    backgroundColor: "#fff"
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: 30,
                    borderBottomColor: "#ECECF4",
                    textAlign: "left"
                },
                head: {
                    borderBottomWidth: 0,
                    lineHeight: 0.73,
                    "&:first-of-type": {
                        borderBottomLeftRadius: 12
                    },
                    "&:last-child": {
                        borderBottomRightRadius: 12
                    }
                },
                body: {
                    fontWeight: 600
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 8
                }
            }
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    "@media (max-width:600px)": {
                        backdropFilter: "blur(2px)"
                    }
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                sizeSmall: {
                    height: 28
                },
                root: {
                    ".MuiChip-deleteIcon": {
                        color: "unset !important",
                        background: "unset !important"
                    }
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    overflowY: "hidden",
                    ".MuiSelect-icon": {
                        position: "absolute",
                        right: "7px !important",
                        left: "unset"
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid transparent"
                    },
                    "&.Mui-disabled": {
                        border: "1px solid transparent"
                    }
                },
                selectMenu: {
                    display: "flex",
                    alignItems: "center"
                },
                outlined: {
                    borderRadius: 12
                }
            }
        },
        MuiSkeleton: {
            styleOverrides: {
                root: {
                    borderRadius: "5px"
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontWeight: 500
                }
            }
        },
        //
        MuiButton: {
            defaultProps: {
                disableElevation: false,
                disableRipple: false,
                disableTouchRipple: true,
                disableFocusRipple: true,
                fullWidth: false
            },
            styleOverrides: {
                root: {
                    borderRadius: "0.8rem",
                    paddingTop: "0.6rem",
                    paddingBottom: "0.6rem",
                    "@media (min-width:0) and (max-width:601px)": {
                        borderRadius: "1.2rem !important"
                    },
                    "&.Mui-disabled": {
                        cursor: "not-allowed",
                        pointerEvents: "none",
                        background: "#D9D9E8",
                        color: "#3F3F8E",
                        border: "1px solid #D9D9E8"
                    }
                },
                sizeLarge: {
                    paddingTop: "1.6rem",
                    paddingBottom: "1.6rem"
                },
                sizeSmall: {
                    paddingTop: "0.7rem",
                    paddingBottom: "0.7rem"
                },
                outlined: {
                    borderColor: "#ecedef"
                }
            }
        },
        MuiLink: {
            defaultProps: {
                underline: "none",
                variant: "subtitle1",
                color: "inherit"
            },
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    transition: "all .04s ease",
                    backfaceVisibility: "hidden",
                    "&[active]": {
                        color: "#FFA500",
                        fontWeight: "bold"
                    },
                    "&:hover": {
                        color: "#FFA500",
                        fontWeight: 500
                    },
                    "&[disabled]": {
                        color: "#7f838f",
                        pointerEvents: "none"
                    }
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                variant: "outlined"
            }
        },
        MuiTooltip: {
            defaultProps: {
                TransitionComponent: _mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z
            },
            styleOverrides: {
                arrow: {
                    color: "#ffffff"
                },
                tooltip: {
                    borderRadius: 8,
                    backgroundColor: "transparent"
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    minHeight: "2rem"
                },
                action: {
                    padding: "0"
                },
                icon: {
                    padding: "0.5rem 0",
                    marginRight: "0",
                    marginLeft: "1.2rem"
                },
                message: {
                    padding: "1rem"
                }
            }
        }
    },
    breakpoints: {
        values: {
            laptop: 1024,
            tablet: 640,
            mobile: 0,
            desktop: 1440,
            //
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536
        }
    }
};



/***/ })

}]);